import { Modal, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, ModalOverlay, useDisclosure } from "@chakra-ui/react";
import { use } from "i18next";
import { useEffect } from "react";
import { Link } from "react-router-dom";

function LocationModal(props: { open: boolean }) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    useEffect(() => {
        const cookieExists = document.cookie.split(';').some((c) => c.trim().startsWith('locationReminderDisplayed='));
        if (props.open && !cookieExists) {
            onOpen();
            document.cookie = "locationReminderDisplayed=true; path=/; max-age=31536000";
        } else if (!props.open) {
            onClose();
        }
    }, [props.open]);
    return (
        <Modal isCentered size={'xl'} isOpen={isOpen} onClose={onClose}>
            <ModalOverlay
                backdropFilter='blur(10px) hue-rotate(90deg)'
            />
            <ModalContent>
                <ModalHeader fontFamily={'Inter'}>Schön, dass du da bist! </ModalHeader>
                <ModalCloseButton />
                <ModalBody fontFamily={'Inter'}>
                    <p>Wir möchten regionalen Austausch noch besser ermöglichen und erfassen deshalb ab jetzt per Postleitzahl den genauen Ort, an dem du arbeitest. Trag ihn gerne
                         <a href='/user-profile?settings=profile' style={{ color: '#60A49F' }}> hier</a> nach. </p>
                    <p>Wenn du dabei bist, schau doch gerne mal, ob du deinem Profil noch weitere Infos hinzufügen kannst, damit dich andere Bildungsenthusiast:innen noch besser finden können.</p>
                </ModalBody>
                <ModalFooter>
                    <Button backgroundColor={'#e09f53'} color={'#fff'} onClick={onClose}>Schließen</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default LocationModal